<page-toolbar [pageActions]="pageActions" title="{{'analytic.title' | translate}}"></page-toolbar>

<mat-tab-group>
  <mat-tab label="Organisation Customers" (click)="selectCustomer('organizationCustomer')">
    <data-table (detail)="onDetailOrgCustomer($event)" [columns]="orgCustomerColumns" [searchColumns]="orgCustomerSearchColumns"
                    [dataProvider]="organisationCustomerService" [title]="'Organisation Customers'"></data-table>
  </mat-tab>

  <mat-tab label="Customers" (click)="selectCustomer('customer')">
    <data-table (detail)="onDetailCustomer($event)" [columns]="customerColumns" [searchColumns]="customerSearchColumns"
                [dataProvider]="customerService" [title]="'Customers'"></data-table>
  </mat-tab>
</mat-tab-group>
